import React from 'react';
import { Checkbox } from '../../common/checkbox';
import { NotificationStates } from './add-user-modal.component';

type NotificationTableProps = {
  notificationStates: NotificationStates;
  updateNotificationState: (
    key: keyof NotificationStates,
    value: boolean,
  ) => void;
  telegramMailing?: boolean;
  maxMailing?: boolean;
};

export default function NotificationTable({
  notificationStates,
  updateNotificationState,
  telegramMailing,
  maxMailing,
}: NotificationTableProps) {
  return (
    <div className="flex flex-column">
      <table className="table table-bordered text-center align-middle w-100">
        <thead>
          <tr>
            <th className="align-text-top">Уведомления</th>
            <th className="align-text-top">СМС</th>
            <th className="align-text-top">Email</th>
            <th className="align-text-top">Телеграм</th>
            <th className="align-text-top">Max</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="text-start">Отправка рекламы</td>
            <td>-</td>
            <td>
              <Checkbox
                className="ms-5"
                checked={notificationStates.promoEmail}
                onChange={(e) =>
                  updateNotificationState('promoEmail', e.target.checked)
                }
              />
            </td>
            <td>-</td>
            <td>-</td>
          </tr>

          <tr>
            <td className="text-start">Отправка сервисных писем</td>
            <td>
              <Checkbox
                className="ms-2"
                checked={notificationStates.serviceSms}
                onChange={(e) =>
                  updateNotificationState('serviceSms', e.target.checked)
                }
              />
            </td>
            <td>
              <Checkbox
                className="ms-5"
                checked={notificationStates.serviceEmail}
                onChange={(e) =>
                  updateNotificationState('serviceEmail', e.target.checked)
                }
              />
            </td>
            <td>
              <Checkbox
                className="ms-4"
                checked={notificationStates.serviceTelegram}
                disabled={!telegramMailing}
                onChange={(e) =>
                  updateNotificationState('serviceTelegram', e.target.checked)
                }
              />
            </td>
            <td>
              <Checkbox
                className="ms-4"
                checked={notificationStates.serviceMax}
                disabled={!maxMailing}
                onChange={(e) =>
                  updateNotificationState('serviceMax', e.target.checked)
                }
              />
            </td>
          </tr>

          <tr>
            <td className="text-start">Отправка сообщений из чата</td>
            <td>-</td>
            <td>
              <Checkbox
                className="ms-5"
                checked={notificationStates.orderChatEmail}
                onChange={(e) =>
                  updateNotificationState('orderChatEmail', e.target.checked)
                }
              />
            </td>
            <td>
              <Checkbox
                className="ms-4"
                checked={notificationStates.orderChatTelegram}
                disabled={!telegramMailing}
                onChange={(e) =>
                  updateNotificationState('orderChatTelegram', e.target.checked)
                }
              />
            </td>
            <td>
              <Checkbox
                className="ms-4"
                checked={notificationStates.orderChatMax}
                disabled={!maxMailing}
                onChange={(e) =>
                  updateNotificationState('orderChatMax', e.target.checked)
                }
              />
            </td>
          </tr>
          <tr>
            <td className="text-start">
              Отправка сообщений о финасовых операциях
            </td>
            <td>-</td>
            <td>-</td>
            <td>
              <Checkbox
                className="ms-4"
                checked={notificationStates.financeTelegram}
                disabled={!telegramMailing}
                onChange={(e) =>
                  updateNotificationState('financeTelegram', e.target.checked)
                }
              />
            </td>
            <td>
              <Checkbox
                className="ms-4"
                checked={notificationStates.financeMax}
                disabled={!maxMailing}
                onChange={(e) =>
                  updateNotificationState('financeMax', e.target.checked)
                }
              />
            </td>
          </tr>

          <tr>
            <td className="text-start">Отправка сообщений об авторизации</td>
            <td>-</td>
            <td>-</td>
            <td>
              <Checkbox
                className="ms-4"
                checked={notificationStates.securityTelegram}
                disabled={!telegramMailing}
                onChange={(e) =>
                  updateNotificationState('securityTelegram', e.target.checked)
                }
              />
            </td>
            <td>
              <Checkbox
                className="ms-4"
                checked={notificationStates.securityMax}
                disabled={!maxMailing}
                onChange={(e) =>
                  updateNotificationState('securityMax', e.target.checked)
                }
              />
            </td>
          </tr>
        </tbody>
      </table>
      {(!telegramMailing || !maxMailing) && (
        <div className="text-muted small">
          <i className="bi bi-exclamation-triangle text-warning me-2"></i>
          Изменение настроек рассылки через ботов Telegram и Max станет доступно
          после подписки клиента на уведомления через личный кабинет.
        </div>
      )}
    </div>
  );
}
